import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AcceptInvite from './pages/AcceptInvite';
import './App.css';

function Root() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [screen, setScreen] = useState('login');
  const [activeProject, setActiveProject] = useState(null);
  const [userRole, setUserRole] = useState('admin');
  const [inviteToken, setInviteToken] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    const inviteMatch = path.match(/^\/invite\/(.+)$/);
    if (inviteMatch) setInviteToken(inviteMatch[1]);

    const token = localStorage.getItem('cms_token');
    const savedUser = localStorage.getItem('cms_user');
    if (token && savedUser) {
      const u = JSON.parse(savedUser);
      setUser(u);
      setScreen(inviteMatch ? 'invite' : 'dashboard');
    } else {
      if (inviteMatch) setScreen('invite');
    }
    setLoading(false);
  }, []);

  const handleLogin = (u) => {
    setUser(u);
    setScreen(inviteToken ? 'invite' : 'dashboard');
  };

  const handleLogout = () => {
    localStorage.removeItem('cms_token');
    localStorage.removeItem('cms_user');
    setUser(null);
    setScreen('login');
    setActiveProject(null);
    window.history.pushState({}, '', '/');
  };

  const handleOpenProject = (project, role) => {
    setActiveProject(project);
    setUserRole(role);
    setScreen('cms');
  };

  if (loading) return (
    <div style={{minHeight:'100vh',background:'#0f0f0f',display:'flex',alignItems:'center',justifyContent:'center',color:'#666',fontFamily:'IBM Plex Sans, sans-serif'}}>
      Loading...
    </div>
  );

  if (screen === 'invite') return (
    <AcceptInvite token={inviteToken} user={user}
      onDone={() => { window.history.pushState({}, '', '/'); setScreen(user ? 'dashboard' : 'login'); }} />
  );

  if (!user || screen === 'login') return <Login onLogin={handleLogin} />;

  if (screen === 'dashboard') return (
    <Dashboard user={user} onOpenProject={handleOpenProject} onLogout={handleLogout} />
  );

  if (screen === 'cms') return (
    <App user={user} userRole={userRole} project={activeProject}
      onBack={() => { setScreen('dashboard'); setActiveProject(null); }} />
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
